/**
 * 
 * key
 * 
 */


const key = 'd29ya2V4cA=='

export default key 